<template>
    <div>
         <vs-navbar center-collapsed v-model="active">
        <template #left>
          <!--<img src="/logo2.png" alt="">-->
        </template>
        <vs-navbar-item :active="active == 'About TACET'" id="About TACET" @click="emitActiveValue(active)">
          About TACET
        </vs-navbar-item>
        <vs-navbar-item :active="active == 'VR Environment'" id="VR Environment" @click="emitActiveValue(active)">
          VR Environment
        </vs-navbar-item>
        <vs-navbar-item :active="active == 'Innovation in Eyetracking'" id="Innovation in Eyetracking" @click="emitActiveValue(active)">
          Innovation in Eyetracking
        </vs-navbar-item>
        <vs-navbar-item :active="active == 'Aquila Jet Training'" id="Aquila Jet Training" @click='window.open("https://aquilajet.training", "_self")'>
          Aquila Jet Training
        </vs-navbar-item>
        <template #right>
          <!--<vs-button flat >Login</vs-button>
          <vs-button>Get Started</vs-button>-->
        </template>
      </vs-navbar>
    </div>
</template>

<script>
import Vue from 'vue'
import { bus } from '../main'
Vue.prototype.window = window;
export default {
    name: "Navbar",
    methods: {
      emitActiveValue(active){
        bus.$emit('updateActiveValue', active)
      }
    },
    data(){
        return {
            active: 'About TACET'
        }
    },
    watch: {
      active: function(active) {
        this.emitActiveValue(active)
      }
    }
  }
</script>

<style scoped>

</style>
